<template lang="pug">
  .main(v-if="main")
    .main__left(:style="`backgroundImage: url(${main.bottle.bg})`")
      .main__left-border.main__left-border--top
      .main__left-border.main__left-border--right
      .main__left-border.main__left-border--bottom
      .main__left-border.main__left-border--left
      .main__left-corner.main__left-corner--tl
      .main__left-corner.main__left-corner--tr
      .main__left-corner.main__left-corner--bl
      .main__left-corner.main__left-corner--br
      .main__left-img-wr(v-if="main.bottle.src", :data-src="main.bottle.src")
        img.main__left-img.main__left-img--hide(:src="main.bottle.src")
      router-link.main__left-btn(v-if="main.menuBtn", :to="main.menuBtn.href") {{main.menuBtn.title}}
    .main__right
      router-link.main__right-item(v-for="item in main.links", :to="item.href", :key="item.id", v-if="item.icon!=='instagram'")
        img.main__right-item-img(:src="item.img")
        SvgIcon(:name="item.icon" width="37" height="47" class="main__right-item-ico")
        .main__right-item-title(v-html="item.title")
      a.main__right-item(:href="item.href", target="_blank" :key="item.id", v-else)
        img.main__right-item-img(:src="item.img")
        SvgIcon(:name="item.icon" width="37" height="47" class="main__right-item-ico")
        .main__right-item-title(v-html="item.title")
</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/main/main.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

// @ is an alias to /src
//import Events from '@/components/events/Events.vue';

export default {
  name: 'Main',

  mixins: [AjaxHelpersVue, ImagePreloaderVue],

  data() {
    return {
      main: null
    }
  },

  components: {
    SvgIcon
    //Events
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadMainPage', params => {
      this.request(params.url);
    });
  },

  methods: {
    request(url) {
      this.req('MainPage:getMainPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.main = res.content;

          this.$nextTick(() => {
            this.imgPreloader('main__left-img-wr', 'main__left-img', '', 250);
          });
        }
      }, 'main');
    },

    /*popupLocal(type, action) {
      this.popup(type, action);
    }*/
  }

}
</script>
